export var OAuthType;
(function (OAuthType) {
    OAuthType["AUTHORIZATION_CODE"] = "authorization_code";
    OAuthType["CLIENT_CREDENTIALS"] = "client_credentials";
})(OAuthType || (OAuthType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJmYWNlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbnRlcmZhY2VzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTBFQSxNQUFNLENBQU4sSUFBWSxTQUdYO0FBSEQsV0FBWSxTQUFTO0lBQ25CLHNEQUF5QyxDQUFBO0lBQ3pDLHNEQUF5QyxDQUFBO0FBQzNDLENBQUMsRUFIVyxTQUFTLEtBQVQsU0FBUyxRQUdwQiJ9